"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useWindowSize2 = _interopRequireDefault(require("../hooks/useWindowSize"));

var _styledComponents = require("styled-components");

var _useScroll = _interopRequireDefault(require("../hooks/useScroll"));

var _context = _interopRequireDefault(require("../context"));

var _style = require("../style");

var _theme = _interopRequireDefault(require("../style/theme"));

var _desktop = _interopRequireDefault(require("./desktop"));

var _mobile = _interopRequireDefault(require("./mobile"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Navigation = function Navigation(_ref) {
  var mainSiteUrl = _ref.mainSiteUrl,
      pageType = _ref.pageType,
      showLogin = _ref.showLogin,
      isProductNavOpen = _ref.isProductNavOpen,
      user = _ref.user,
      logOutUser = _ref.logOutUser,
      isInitInProgress = _ref.isInitInProgress,
      parallaxChildrenRef = _ref.parallaxChildrenRef,
      avatarElement = _ref.avatarElement,
      linkComponent = _ref.linkComponent,
      enableRemoteDoctor = _ref.enableRemoteDoctor,
      children = _ref.children;

  var _useWindowSize = (0, _useWindowSize2.default)(),
      width = _useWindowSize.width;

  var lastScrollPos = (0, _react.useRef)(0);
  var isHomepage = pageType.isHomepage,
      isGlobal = pageType.isGlobal;

  var _useState = (0, _react.useState)(isHomepage || isGlobal),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var isDesktop = width >= _style.SCREEN_SIZES.desktop;
  (0, _react.useEffect)(function () {
    setIsVisible(isHomepage || isGlobal);
  }, [isHomepage, isGlobal]);
  var handleScroll = (0, _react.useCallback)(function (currentScrollPos) {
    var scrollHeight = currentScrollPos + window.innerHeight;
    if (!isDesktop && isProductNavOpen && !isHomepage || isDesktop && !isHomepage || isGlobal) return;

    if (currentScrollPos <= 0) {
      setIsVisible(isHomepage);
    } else if (currentScrollPos >= scrollHeight) {
      setIsVisible(false);
    } else {
      setIsVisible(currentScrollPos < lastScrollPos.current);
    }

    lastScrollPos.current = currentScrollPos;
  }, [isGlobal, isHomepage, lastScrollPos, isProductNavOpen, isDesktop]);
  (0, _useScroll.default)(handleScroll, parallaxChildrenRef);
  (0, _react.useEffect)(function () {
    setIsVisible(isHomepage || isGlobal ? isVisible : isProductNavOpen);
  }, [isProductNavOpen]); // eslint-disable-line

  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_context.default.Provider, {
    value: {
      mainSiteUrl: mainSiteUrl,
      linkComponent: linkComponent
    }
  }, isDesktop ? /*#__PURE__*/_react.default.createElement(_desktop.default, {
    pageType: pageType,
    mainSiteUrl: mainSiteUrl,
    showLogin: showLogin,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    isToggleable: !isGlobal,
    logOutUser: logOutUser,
    user: user,
    isInitInProgress: isInitInProgress,
    avatarElement: avatarElement,
    enableRemoteDoctor: enableRemoteDoctor
  }, children) : /*#__PURE__*/_react.default.createElement(_mobile.default, {
    pageType: pageType,
    mainSiteUrl: mainSiteUrl,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    logOutUser: logOutUser,
    user: user,
    isInitInProgress: isInitInProgress,
    avatarElement: avatarElement,
    enableRemoteDoctor: enableRemoteDoctor
  }, children)));
};

Navigation.propTypes = {
  mainSiteUrl: _propTypes.default.string.isRequired,
  pageType: _propTypes.default.object,
  showLogin: _propTypes.default.bool,
  isProductNavOpen: _propTypes.default.bool,
  user: _propTypes.default.object,
  logOutUser: _propTypes.default.func,
  isInitInProgress: _propTypes.default.bool,
  parallaxChildrenRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  avatarElement: _propTypes.default.node,
  linkComponent: _propTypes.default.any,
  enableRemoteDoctor: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = Navigation;
exports.default = _default;